<mat-sidenav-container class="wrapper">
  <mat-sidenav #sidenav class="sidenav" mode="over" (closed)="closeZe(sidenav)" (openedStart)="openZe(sidenav)">
    <app-sidemenu></app-sidemenu>
  </mat-sidenav>

  <div class="sidenav-content">
    <div class="main-content" [class.show-chat]="toggleChat() && isMobile()">
      <mat-toolbar>
        <button mat-icon-button (click)="sidenav.open()">
          <mat-icon>menu</mat-icon>
        </button>
        <div class="page-title">
          {{adminService.pageTitle() | truncate: ['30']}}
        </div>
        <div class="expander">
          <ng-container *ngIf="locations && locations.length > 1" >
  
            <mat-select placeholder="{{heading?.locale_name || 'Local'}}" [multiple]="true" (ngModelChange)="setLocations($event)" [(ngModel)]="location" required class="local-selector display-desktop">
              <mat-checkbox [checked]="areAllSelected()" (change)="toggleSelectAllLocations($event)">Todos</mat-checkbox>
              <mat-option *ngFor="let location of locations" [value]="location.id">{{location.name}}</mat-option>
            </mat-select>
          </ng-container>
        </div>
        <div class="toggle-sidebar display-mobile" style="margin-right: 5px;" (click)="openLocalSelector()" *ngIf="locations && locations.length > 1">
          <button mat-icon-button>
            <mat-icon>store</mat-icon>
          </button>
        </div>
        <div class="toggle-sidebar" (click)="toggleChat.set(!toggleChat())" [class.allowed]="allowedNotifications | async" class="hide-mobile">
          <button mat-icon-button>
            <mat-icon>chat_bubble</mat-icon>
            <div class="unread" *ngIf="unreadChat.unread > 0 && unreadChat.mention === 0">
              
            </div>
            <div class="mention" *ngIf="unreadChat.mention > 0">
              <span>{{unreadChat.mention}}</span>
            </div>
            <div class="work-count" *ngIf="unreadChat.workCount > 0">
              <span>{{unreadChat.workCount}}</span>
            </div>
          </button>
        </div>
      </mat-toolbar>
      <app-chat [hidden]="!toggleChat()" (unreadMessages)="setUnread($event)" *ngIf="isMobile()" [class.mobile]="isMobile()" (openChatEvent)="toggleChat.set(true)"></app-chat>
      <div class="main-page">
        <router-outlet></router-outlet>
      </div>
      <mat-toolbar class="toolbarNav">
        <div class="button" (click)="toggleChat.set(false)" [class.active]="!toggleChat()">
          <button mat-icon-button>
            <mat-icon>home</mat-icon>
          </button>
        </div>
        <div class="button" (click)="toggleChat.set(true)" [class.active]="toggleChat()">
          <button mat-icon-button>
            <mat-icon>chat_bubble</mat-icon>
            <div class="unread" *ngIf="unreadChat.unread > 0 && unreadChat.mention === 0">
              
            </div>
            <div class="mention" *ngIf="unreadChat.mention > 0">
              <span>{{unreadChat.mention}}</span>
            </div>
            <div class="work-count" *ngIf="unreadChat.workCount > 0">
              <span>{{unreadChat.workCount}}</span>
            </div>
          </button>
        </div>
      </mat-toolbar>
    </div>
    <app-chat [hidden]="!toggleChat()" (unreadMessages)="setUnread($event)" *ngIf="!isMobile()" (openChatEvent)="toggleChat.set(true)"></app-chat>
  </div>


</mat-sidenav-container>
